<!-- Apple-style Modern Layout -->
<div class="apple-layout">
  <!-- Apple Navigation Bar -->
  <nav class="apple-navbar" [class.scrolled]="isScrolled">
    <div class="apple-navbar-container">
      <!-- Logo -->
      <div class="apple-navbar-logo" routerLink="/">
        <mat-icon class="logo-icon">attach_money</mat-icon>
        <span class="logo-text">NicLen</span>
      </div>

      <!-- Main Navigation -->
      <div class="apple-navbar-nav" *ngIf="isAuthenticated">
        <ng-container *ngFor="let navItem of navigationItems">
          <!-- Parent nav item -->
          <div class="apple-nav-item"
               [class.active]="isActiveRoute(navItem.route)"
               [class.has-children]="navItem.children?.length">
            <a (click)="onNavItemClick(navItem)"
               class="nav-link"
               (mouseenter)="onNavHover(navItem)"
               (mouseleave)="onNavLeave(navItem)">
              <mat-icon class="nav-icon">{{ navItem.icon }}</mat-icon>
              <span>{{ navItem.label }}</span>
              <mat-icon *ngIf="navItem.children?.length" class="nav-chevron">expand_more</mat-icon>
            </a>

            <!-- Dropdown for children -->
            <div class="apple-dropdown"
            *ngIf="navItem.children?.length && hoveredItem === navItem"
            (mouseenter)="onDropdownEnter(navItem)"
            (mouseleave)="onNavLeave(navItem)">
              <div class="dropdown-content">
                <div *ngFor="let childItem of navItem.children" class="dropdown-item">
                  <a (click)="onChildNavClick(childItem)">
                    <mat-icon>{{ childItem.icon }}</mat-icon>
                    <span>{{ childItem.label }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Right Actions -->
      <div class="apple-navbar-actions">
        <!-- Order Search (Employee only) -->
        <app-order-search *ngIf="isAuthenticated && isEmployee()"></app-order-search>

        <!-- Dark Mode Toggle -->
        <button class="apple-icon-button"
                (click)="toggleDarkMode()"
                [matTooltip]="(darkMode$ | async) ? 'Heller Modus' : 'Dunkler Modus'">
          <mat-icon>{{ (darkMode$ | async) ? 'light_mode' : 'dark_mode' }}</mat-icon>
        </button>

        <ng-container *ngIf="isAuthenticated; else loginBlock">
          <!-- Notifications -->
          <button class="apple-icon-button"
                  [matMenuTriggerFor]="notificationMenu"
                  [matBadge]="unreadCount"
                  [matBadgeHidden]="unreadCount === 0"
                  matBadgeColor="warn"
                  matTooltip="Benachrichtigungen">
            <mat-icon>notifications</mat-icon>
          </button>

          <!-- User Menu -->
          <button class="apple-user-button" [matMenuTriggerFor]="userMenu">
            <div class="user-avatar-small">{{ getInitials() }}</div>
          </button>

          <!-- Notification Menu -->
          <mat-menu #notificationMenu="matMenu" class="apple-menu notification-menu" xPosition="before">
            <div class="apple-menu-header">
              <h3 class="apple-heading-5">Benachrichtigungen</h3>
            </div>
            <ng-container *ngIf="(notifications | async)!.length > 0; else noNotifications">
              <div *ngFor="let note of notifications | async"
                   class="notification-item"
                   [class.unread]="!note.isRead">
                <mat-icon class="notification-icon">{{ note.isRead ? 'mail_outline' : 'mark_email_unread' }}</mat-icon>
                <div class="notification-content">
                  <div class="notification-title">{{ note.title || 'Notification' }}</div>
                  <div class="notification-message">{{ note.message }}</div>
                  <div class="notification-time">{{ note.createdAt | date:'short' }}</div>
                </div>
                <button class="notification-action"
                        [routerLink]="note.link"
                        (click)="markNotificationsRead(note)">
                  <mat-icon>chevron_right</mat-icon>
                </button>
              </div>
            </ng-container>
            <ng-template #noNotifications>
              <div class="empty-state-small">
                <mat-icon>notifications_off</mat-icon>
                <p>Keine neuen Benachrichtigungen</p>
              </div>
            </ng-template>
            <div class="apple-menu-footer">
              <button class="apple-button apple-button-text" routerLink="notifications">
                Alle anzeigen
              </button>
            </div>
          </mat-menu>

          <!-- User Menu -->
          <mat-menu #userMenu="matMenu" class="apple-menu user-menu" xPosition="before">
            <div class="apple-menu-header user-menu-header">
              <div class="user-avatar-large">{{ getInitials() }}</div>
              <div class="user-info">
                <h3 class="apple-heading-5">{{ getCompactName() }}</h3>
                <p class="apple-caption">{{ currentUser?.email }}</p>
                <span class="user-badge">{{ getUserTypeDisplay() }}</span>
              </div>
            </div>
            <div class="apple-menu-section">
              <button class="apple-menu-item" (click)="navigateToProfile()">
                <mat-icon>person</mat-icon>
                <span>Profil</span>
              </button>
              <button class="apple-menu-item" (click)="navigateToSettings()">
                <mat-icon>settings</mat-icon>
                <span>Einstellungen</span>
              </button>
              <button class="apple-menu-item" (click)="navigateToHelp()">
                <mat-icon>help</mat-icon>
                <span>Hilfe & Support</span>
              </button>
            </div>
            <div class="apple-menu-footer">
              <button class="apple-menu-item logout-item" (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>Abmelden</span>
              </button>
            </div>
          </mat-menu>
        </ng-container>

        <ng-template #loginBlock>
          <!-- Login button removed - users can access login via /login page or footer -->
        </ng-template>
      </div>
    </div>
  </nav>

  <!-- Main Content -->
  <main class="apple-main-content" [@routeAnimations]="router.url">
    <router-outlet />
    <app-footer />
  </main>

  <app-loading-indicator />
</div>
